/**
 * ui8-fade-in: image preloader.
 *
 * The <img> starts transparent and fades in when its bytes arrive; while it
 * is pending, the parent carries `img-pending` so it can show a placeholder
 * (see components/fade-in.sass). Images the browser already has (cache,
 * bfcache, in-app return) reveal instantly with no transition, so a warm
 * page never "re-animates". A src/srcset swap (search drawer, ui8-image
 * setting src after link) goes back to pending until the new image loads.
 * On error the img is revealed anyway rather than left invisible.
 */
angular.module("UI8.directives").directive("ui8FadeIn", [
  function () {
    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        var img = elem[0];
        if (!img || img.tagName !== "IMG") return;
        var parent = img.parentElement;
        // when the current source was set; a load that completes within
        // INSTANT_MS of it came from cache and must not animate
        var pendingAt = 0;
        var INSTANT_MS = 100;

        function pending() {
          pendingAt = performance.now();
          elem.removeClass("is-loaded no-anim");
          if (parent) parent.classList.add("img-pending");
        }

        function loaded(instant) {
          if (instant) elem.addClass("no-anim");
          elem.addClass("is-loaded");
          if (parent) parent.classList.remove("img-pending");
        }

        function check() {
          // ng-src / ui8-image have not set a source yet
          if (!img.getAttribute("src") && !img.getAttribute("srcset"))
            return pending();
          if (img.complete && img.naturalWidth > 0) return loaded(true);
          pending();
        }

        // Cache hit: either the load completed right after the source was
        // set, or Resource Timing shows the fetch itself took no time (the
        // lazy-load scheduler can start the fetch long after src was set).
        function fromCache() {
          if (performance.now() - pendingAt < INSTANT_MS) return true;
          var src = img.currentSrc || img.src;
          if (!src || !performance.getEntriesByName) return false;
          var entries = performance.getEntriesByName(src);
          var entry = entries[entries.length - 1];
          return !!entry && entry.responseEnd - entry.startTime < INSTANT_MS;
        }

        img.addEventListener("load", function () {
          loaded(fromCache());
        });
        img.addEventListener("error", function () {
          loaded(false);
        });

        check();

        if (window.MutationObserver) {
          var observer = new MutationObserver(check);
          observer.observe(img, {
            attributes: true,
            attributeFilter: ["src", "srcset"],
          });
          scope.$on("$destroy", function () {
            observer.disconnect();
          });
        } else if (attrs.ngSrc) {
          attrs.$observe("ngSrc", check);
        }
      },
    };
  },
]);
